module.exports = __webpack_public_path__ + "img/3-Icon-Citizenship.3efa1fcd.png";